import { SliceClass } from 'interfaces';
import { NewLandingPageDocumentDataBodyCenteredAccordionSlice } from '../../../types.generated.interface';
import { AccordionItem } from './accordian-item';

export class CenteredAccordionSlice extends SliceClass {
  public title: string;
  public items: AccordionItem[];
  public sectionId: string;

  constructor(sliceData: NewLandingPageDocumentDataBodyCenteredAccordionSlice, title: string, items: AccordionItem[]) {
    super(sliceData);
    this.title = title;
    this.items = items;
    this.sectionId = sliceData.primary.section_id;
  }
}
